import React from 'react';
import { Star, ShieldCheck, CheckCircle2, Award } from 'lucide-react';
export function TopBar() {
  const items = [{
    Icon: Star,
    text: 'Más de 25,000 estudiantes'
  }, {
    Icon: ShieldCheck,
    text: 'Pago 100% seguro'
  }, {
    Icon: CheckCircle2,
    text: 'Acceso inmediato de por vida'
  }, {
    Icon: Award,
    text: 'Actualizaciones gratuitas'
  }];
  return <div className="bg-brand-green border-b border-brand-gold/15 text-white relative z-50" data-id="element-1045" data-mp="2qr6gohh5n4hk">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-1046" data-mp="2lupqziub4i2d">
        {/* Desktop & tablet: single row */}
        <div className="hidden sm:flex items-center justify-between md:justify-around gap-4 py-2.5" data-id="element-1047" data-mp="2h1dda3r61voe">
          {items.map(({
          Icon,
          text
        }, i) => <div key={i} className="flex items-center gap-2 whitespace-nowrap" data-id="element-1048" data-mp="39iz847gkshn6" data-mpi={i}>
              <Icon className="w-3.5 h-3.5 text-brand-gold flex-shrink-0" strokeWidth={2.5} data-id="element-1049" data-mp="39l27hi3mbn4k" />
              <span className="text-[11px] md:text-xs font-semibold tracking-wide text-white/90" data-id="element-1050" data-mp="24prooctpqyg">
                {text}
              </span>
            </div>)}
        </div>

        {/* Mobile: 2x2 grid */}
        <div className="sm:hidden grid grid-cols-2 gap-x-3 gap-y-1.5 py-2.5" data-id="element-1051" data-mp="3ojrai4ym6qnx">
          {items.map(({
          Icon,
          text
        }, i) => <div key={i} className="flex items-center gap-1.5 min-w-0" data-id="element-1052" data-mp="3ti2jkdh34x53" data-mpi={i}>
              <Icon className="w-3 h-3 text-brand-gold flex-shrink-0" strokeWidth={2.5} data-id="element-1053" data-mp="3ellajswdbulp" />
              <span className="text-[10px] font-semibold tracking-wide text-white/90 truncate" data-id="element-1054" data-mp="3jjmq43ul5bsf">
                {text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}